import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { Button, DropDown } from "nlib/ui";
import { DropDownContent, DropDownMenuItem } from "nlib/ui/DropDown";
import React, { useRef, useState } from "react";
import classNames from "classnames";

const MultiButton = ({ buttons = [], className }) => {
  const filteredButtons = buttons.filter(Boolean);

  const toggleRef = useRef(null);

  const [opened, setOpened] = useState(false);

  if (!filteredButtons.length) return null;

  const [firstButton, ...restButtons] = filteredButtons;

  const {
    content: firstButtonContent,
    className: firstButtonClassName,
    ...firstButtonProps
  } = firstButton || {};

  return (
    <div className={classNames(Css.multiButton, !restButtons.length && Css.oneButton, className)}>
      <div className={Css.buttons}>
        {!!firstButton && (
          <Button
            className={classNames(Css.firstButton, firstButtonClassName)}
            {...firstButtonProps}>
            {firstButtonContent}
          </Button>
        )}
        {!!restButtons.length && (
          <Button
            outline
            ref={toggleRef}
            className={Css.dropdownToggle}
            secondary={firstButton.secondary}
            primary={firstButton.primary}
            danger={firstButton.danger}>
            {opened ? <Icons.CaretUp /> : <Icons.CaretDown />}
          </Button>
        )}
      </div>
      {!!restButtons.length && (
        <DropDown opened={opened} setOpened={setOpened} toggleRef={toggleRef}>
          <DropDownContent alignRight className={Css.dropdownContent}>
            {restButtons.map(({ key, content, outline, ...restProps }) => (
              <DropDownMenuItem key={key} {...restProps}>{content}</DropDownMenuItem>
            ))}
          </DropDownContent>
        </DropDown>
      )}
    </div>
  );
};

export default React.memo(MultiButton);
